// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3067":"0d107434","3806":"b16b3396","5940":"ad0e7e55","7977":"b16b3396"}[chunkId] + ".chunk.css";
};